import React from "react";
import WerkbonView from "./WerkbonView";

export default function MonteurWerkbonnenPage() {
  return <WerkbonView />;
}
